import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ReviewHeader = ({ product, onAddToComparison, onShareReview }) => {
  return (
    <div className="bg-white rounded-xl shadow-subtle border border-border p-6 lg:p-8 mb-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Product Image */}
        <div className="relative">
          <div className="aspect-square bg-muted rounded-lg overflow-hidden">
            <Image
              src={product?.image}
              alt={product?.imageAlt}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
          {product?.badge && (
            <div className="absolute top-4 left-4 bg-accent text-accent-foreground px-3 py-1 rounded-full text-sm font-medium">
              {product?.badge}
            </div>
          )}
        </div>

        {/* Product Info */}
        <div className="space-y-6">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-sm text-muted-foreground">{product?.brand}</span>
              <Icon name="Dot" size={12} className="text-muted-foreground" />
              <span className="text-sm text-muted-foreground">{product?.category}</span>
            </div>
            <h1 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
              {product?.name}
            </h1>
            <p className="text-lg text-text-secondary leading-relaxed">
              {product?.description}
            </p>
          </div>

          {/* Rating & Reviews */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="flex items-center">
                {[...Array(5)]?.map((_, i) => (
                  <Icon
                    key={i}
                    name="Star"
                    size={20}
                    className={`${
                      i < Math.floor(product?.rating)
                        ? 'text-accent fill-current' :'text-muted-foreground'
                    }`}
                  />
                ))}
              </div>
              <span className="text-xl font-semibold text-text-primary">
                {product?.rating}
              </span>
            </div>
            <div className="text-sm text-muted-foreground">
              Based on {product?.reviewCount} reviews
            </div>
          </div>

          {/* Price & Actions */}
          <div className="space-y-4">
            <div className="flex items-baseline gap-3">
              <span className="text-3xl font-bold text-primary">
                ${product?.currentPrice}
              </span>
              {product?.originalPrice && (
                <span className="text-lg text-muted-foreground line-through">
                  ${product?.originalPrice}
                </span>
              )}
              {product?.discount && (
                <span className="bg-success text-success-foreground px-2 py-1 rounded text-sm font-medium">
                  {product?.discount}% OFF
                </span>
              )}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                variant="default"
                size="lg"
                iconName="ExternalLink"
                iconPosition="right"
                className="flex-1"
              >
                Check Best Price
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="GitCompare"
                iconPosition="left"
                onClick={onAddToComparison}
              >
                Add to Compare
              </Button>
              <Button
                variant="ghost"
                size="lg"
                iconName="Share2"
                onClick={onShareReview}
              >
                Share
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewHeader;